import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Dropzone from 'react-dropzone-uploader';
import FormData from 'form-data';
import * as actions from '../redux/actions';
import classnames from 'classnames';
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import * as Yup from 'yup';
import CustomLoader from '../../common/CustomLoader';
import { builderSurfaceMultiPartHeader } from '../../../common/utils/restApiHeaderUtils';

export class AssetUploader extends Component {
  static propTypes = {
    editor: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    projectId: PropTypes.string.isRequired,
  };

  state = { activeTab: '1' };

  toggle = (activeTab) => {
    this.setState({ activeTab });
  };

  showCard = () => {
    return {
      display: !this.props.editor.toggleAsset ? 'none' : '',
    };
  };

  getUploadParams = ({ file, meta }) => {
    const { projectId, version } = this.props;
    const { headers } = builderSurfaceMultiPartHeader(projectId);
    const body = new FormData();
    const originalFileName = meta.name;
    const randomFileName = Math.random().toString(36).substring(7);
    const fileExtension = originalFileName.split('.').pop();
    const cleanedFileName = `${randomFileName}.${fileExtension}`;
    const encodedFileName = encodeURIComponent(cleanedFileName);
    body.append('x-amz-meta-originalname', encodedFileName);
    body.append('file', file, cleanedFileName);
    return {
      url: `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/assets/${projectId}`,
      body: body,
      headers,
    };
  };

  handleChangeStatus = ({ meta, file, xhr }, status) => {
    const { projectId, version } = this.props;
    if (status === 'done') {
      this.props.actions.loadProjectAssets({ projectId, version });
    }
  };

  prepareValidation = () => {
    let validationSchema = {
      url: Yup.string().required("URL can't be blank"),
    };
    return Yup.object().shape(validationSchema);
  };

  handleURLImageUpload = (values) => {
    const { projectId, version } = this.props;
    values.projectId = projectId;
    values.version = version;
    this.props.actions.uploadImageFromUrl(values);
  };

  showImageUploadeFromUrl = () => {
    const { uploadImageFromUrlPending } = this.props.editor;
    return (
      <Fragment>
        <Formik
          initialValues={{ url: '' }}
          validationSchema={this.prepareValidation()}
          onSubmit={(values, { resetForm }) => {
            this.handleURLImageUpload(values);
            resetForm();
          }}
        >
          {({ isSubmitting, values, errors }) => (
            <Form>
              <div className="row" style={{ minHeight: '200px' }}>
                <div className="col-12">
                  <div className="form-group">
                    <Field
                      type="text"
                      name="url"
                      className="form-control form-control-sm"
                      placeholder="Asset URL"
                    />
                    <p className="text-danger">
                      <ErrorMessage name={'url'} />
                    </p>
                  </div>
                  <div className="text-right">
                    <div className="" role="group">
                      <button
                        type="submit"
                        className="btn btn-theme-submit btn-sm"
                        disabled={uploadImageFromUrlPending}
                      >
                        <i className="wb webconnect-upload"></i>&nbsp; Upload &nbsp;
                        <CustomLoader loading={uploadImageFromUrlPending} />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </Fragment>
    );
  };

  render() {
    const { activeTab } = this.state;
    return (
      <div className="gjs-mdl-container" style={this.showCard()}>
        <div className="gjs-mdl-dialog gjs-one-bg gjs-two-color">
          <div className="gjs-mdl-header">
            <div className="gjs-mdl-title">
              <Nav tabs>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === '1' })}
                    onClick={() => this.toggle('1')}
                  >
                    Upload Asset
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === '2' })}
                    onClick={() => this.toggle('2')}
                  >
                    Upload Using URL
                  </NavLink>
                </NavItem>
              </Nav>
            </div>
            <div
              className="gjs-mdl-btn-close"
              onClick={this.props.actions.toggleAssetUplod}
              data-close-modal=""
            >
              ⨯
            </div>
          </div>
          <div className="gjs-mdl-content">
            <div id="gjs-mdl-c">
              <TabContent activeTab={activeTab}>
                {activeTab === '1' && this.props.editor.toggleAsset ? (
                  <TabPane tabId="1">
                    <Dropzone
                      getUploadParams={this.getUploadParams}
                      onChangeStatus={this.handleChangeStatus}
                      maxSizeBytes="20971520"
                      maxFiles="10"
                      accept="image/*"
                      disabled={(files) =>
                        files.some((f) =>
                          ['preparing', 'getting_upload_params', 'uploading'].includes(
                            f.meta.status,
                          ),
                        )
                      }
                      styles={{
                        dropzone: { minHeight: 200, maxHeight: 250, borderColor: '#c3cfe9' },
                        dropzoneActive: { borderColor: 'green' },
                      }}
                    />
                  </TabPane>
                ) : (
                  ''
                )}
                <TabPane tabId="2">{this.showImageUploadeFromUrl()}</TabPane>
              </TabContent>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    editor: state.editor,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AssetUploader);
